import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { GET_CHECKLIST_POSSESION_LIST, GET_CHECKLIST_EXIST_LIST, getCheckListExistListUrl, getCheckListPossessionListUrl, insertCheckListPossessionListUrl, INSERT_CHECKLIST_POSSESION_LIST, headers, INSERT_CHECKLIST_EXIST_LIST, insertExitListUrl, SEND_NEW_PI_EXIST_LIST, sendNewPIUrl } from "../../utils/constants"
import moment from 'moment';

export const get_possession_list_action = (CenterID, OrderID, VendorIdAndServiceIdList) => async (dispatch) => {
    try {
        const mapdata = {
            userId: parseInt(sessionStorage.getItem('userId')),
            CenterID: CenterID,
            OrderID: OrderID,
            VendorIdAndServiceIdList: VendorIdAndServiceIdList
        }
        console.log("get_possession_list_action--", mapdata)
        const res = await axiosGet(getCheckListPossessionListUrl, mapdata, headers);

        dispatch({
            type: GET_CHECKLIST_POSSESION_LIST,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const insert_possession_list_action = (OrderID, PossessionElectricityUnit, possessionIncludedServices, PossessionCheckList, PossessionFilePath, OrderNo, PossessionContactNameAndNumber, ConsumableIDList, VendorIdAndServiceIdList, CenterSecurityChecklistIDList, PossessionSecurityChecklistNote, VendorPackageNoteList, PossesionOperationSignature, PosssesionOpeartionNameContact, PrimaryEmailID) => async (dispatch) => {
    try {
        const mapdata = {
            userId: parseInt(sessionStorage.getItem('userId')),
            OrderID: OrderID,
            PossessionElectricityUnit: PossessionElectricityUnit,
            PossessionIncludedServices: possessionIncludedServices,
            PossessionCheckList: PossessionCheckList,
            PossessionFilePath: PossessionFilePath,
            OrderNo: OrderNo != '' ? OrderNo : null,
            flag: 0,
            PossessionContactNameAndNumber: PossessionContactNameAndNumber,
            ConsumableIDList: ConsumableIDList,
            VendorIdAndServiceIdList: VendorIdAndServiceIdList,
            CenterSecurityChecklistIDList: CenterSecurityChecklistIDList,
            PossessionSecurityChecklistNote: PossessionSecurityChecklistNote,
            VendorPackageNoteList: VendorPackageNoteList,
            PossesionOperationSignature: PossesionOperationSignature,
            PosssesionOpeartionNameContact: PosssesionOpeartionNameContact,
            PrimaryEmailID: PrimaryEmailID,
        }
        console.log("insert_possession_list_action", mapdata)
        const res = await axiosPost(insertCheckListPossessionListUrl, mapdata, headers);

        dispatch({
            type: INSERT_CHECKLIST_POSSESION_LIST,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const get_exist_list_action = (CenterID, OrderID, VendorIdAndServiceIdList) => async (dispatch) => {
    try {
        const mapdata = {
            userId: parseInt(sessionStorage.getItem('userId')),
            CenterID: CenterID,
            OrderID: OrderID,
            VendorIdAndServiceIdList: VendorIdAndServiceIdList,
        }
        const res = await axiosGet(getCheckListExistListUrl, mapdata, headers);

        dispatch({
            type: GET_CHECKLIST_EXIST_LIST,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const insert_exist_list_action = (OrderID, ExitIncludedServices, ExitInhouseServices, ExitCheckList, ExitFilePath, ExitRemark, OrderNo, AdditionHours, ExitElectricityUnit, VendorList, ExitContactNameAndNumber, ConsumableIDList, VendorIdAndServiceIdList, CenterSecurityChecklistIDList, ExitSecurityChecklistNote, VendorPackageNoteList, FinalExitSubmit, ExitOprationSignature, ExitOperationNameContact, securityEmailData, param, PrimaryEmailID, AsAmount, companyName, isExitClientSubmitted, exitAddChargesWaveOff, exitAddChargesWaveOffRemark, ChargeableElectricityUnit) => async (dispatch) => {
    try {
        const mapdata = {
            userId: parseInt(sessionStorage.getItem('userId')),
            OrderID: OrderID,
            ExitIncludedServices: ExitIncludedServices,
            ExitInhouseServices: ExitInhouseServices,
            ExitCheckList: ExitCheckList,
            ExitFilePath: ExitFilePath != '' ? ExitFilePath : null,
            ExitRemark: ExitRemark != '' ? ExitRemark : null,
            OrderNo: OrderNo != '' ? OrderNo : null,
            flag: 1,
            AdditionHours: AdditionHours,
            ExitElectricityUnit: ExitElectricityUnit,
            VendorList: VendorList,
            ExitContactNameAndNumber: ExitContactNameAndNumber,
            ConsumableIDList: ConsumableIDList,
            VendorIdAndServiceIdList: VendorIdAndServiceIdList,
            CenterSecurityChecklistIDList: CenterSecurityChecklistIDList,
            ExitSecurityChecklistNote: ExitSecurityChecklistNote,
            VendorPackageNoteList: VendorPackageNoteList,
            FinalExitSubmit: FinalExitSubmit,
            ExitOprationSignature: ExitOprationSignature != '' ? ExitOprationSignature : null,
            ExitOperationNameContact: ExitOperationNameContact,
            SecurityEmailData: securityEmailData,
            param: param,
            PrimaryEmailID: PrimaryEmailID,
            AsAmount: AsAmount != null ? AsAmount : 0,
            companyName: companyName != "" ? companyName : "",
            isExitClientSubmitted: isExitClientSubmitted,
            exitAddChargesWaveOff: exitAddChargesWaveOff == true ? exitAddChargesWaveOff : false,
            exitAddChargesWaveOffRemark: exitAddChargesWaveOffRemark != "" ? exitAddChargesWaveOffRemark : "",
            ChargeableElectricityUnit: ChargeableElectricityUnit != "" ? ChargeableElectricityUnit : ""
        }
        const res = await axiosPost(insertExitListUrl, mapdata, headers);

        dispatch({
            type: INSERT_CHECKLIST_EXIST_LIST,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const send_new_pi_action = (OrderNo, OrderID, companyName, primaryEmailID, ProformaInvoiceID, ProformaInvoice_No,SecurityEmailData,addHrs) => async (dispatch) => {
    try {
        const mapdata = {
            userId: parseInt(sessionStorage.getItem('userId')),
            OrderNo: OrderNo,
            OrderID: OrderID,
            companyName: companyName,
            primaryEmailID: primaryEmailID,
            ProformaInvoiceID: ProformaInvoiceID,
            ProformaInvoice_No: ProformaInvoice_No,
            SecurityEmailData: SecurityEmailData,
            addHrs: addHrs,
        }
        const res = await axiosPost(sendNewPIUrl, mapdata, headers);

        dispatch({
            type: SEND_NEW_PI_EXIST_LIST,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

